// extracted by mini-css-extract-plugin
export default {"Controls":"styles_Controls__uG1N-","buttonsContainer":"styles_buttonsContainer__LSgsq","noActiveButton":"styles_noActiveButton__EfIfL"};